var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0006 12.9236V15.3205C17.0015 15.543 16.9559 15.7632 16.8668 15.9671C16.7776 16.171 16.6469 16.354 16.4829 16.5044C16.319 16.6548 16.1254 16.7693 15.9146 16.8406C15.7038 16.9119 15.4805 16.9384 15.2589 16.9184C12.8004 16.6512 10.4389 15.8111 8.364 14.4656C6.43361 13.2389 4.79698 11.6023 3.57033 9.67193C2.2201 7.58764 1.37982 5.21461 1.11757 2.74507C1.0976 2.52414 1.12386 2.30147 1.19467 2.09124C1.26547 1.88101 1.37928 1.68782 1.52884 1.52398C1.6784 1.36014 1.86043 1.22924 2.06335 1.13961C2.26627 1.04998 2.48563 1.00358 2.70747 1.00337H5.1043C5.49204 0.999557 5.86793 1.13686 6.16192 1.38969C6.4559 1.64252 6.64793 1.99362 6.70219 2.37756C6.80336 3.1446 6.99097 3.89773 7.26145 4.62259C7.36895 4.90855 7.39221 5.21934 7.32849 5.51811C7.26477 5.81689 7.11674 6.09114 6.90193 6.30837L5.88727 7.32303C7.02461 9.32322 8.68074 10.9794 10.6809 12.1167L11.6956 11.102C11.9128 10.8872 12.1871 10.7392 12.4859 10.6755C12.7846 10.6118 13.0954 10.635 13.3814 10.7425C14.1062 11.013 14.8594 11.2006 15.6264 11.3018C16.0145 11.3565 16.3689 11.552 16.6223 11.851C16.8757 12.1501 17.0103 12.5318 17.0006 12.9236Z",
    stroke: "white",
    strokeWidth: 1.59789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/calling.41de6af196ccc64b00f25a37063a010a.svg";
export { ForwardRef as ReactComponent };